export default __webpack_public_path__ + "static/media/bill-back.9479bbe6.svg";